export default "__VITE_ASSET__CeDsl4Zy__"